"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ = require("./");

var _SearchResultIcon = _interopRequireDefault(require("./SearchResultIcon"));

var _components = require("@insided/destination/modules/Search/components");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var SearchResult = function SearchResult(props) {
  var _hit$topic_url;

  var key = props.key,
      hit = props.hit,
      isHighlited = props.isHighlited,
      type = props.type,
      getItemProps = props.getItemProps,
      index = props.index;
  var target = !(0, _.isCommunityResult)(hit) ? '_blank' : '';
  var rel = !(0, _.isCommunityResult)(hit) ? 'noreferrer' : '';

  var parsedTitle = _htmlParser.default.stripHtml(hit.title);

  return (0, _preact.h)("li", {
    key: key,
    className: "algolia-search-result algolia-search-result--".concat(type),
    style: {
      backgroundColor: isHighlited ? '#F2F2F2' : ''
    },
    role: "option",
    "aria-selected": isHighlited
  }, (0, _preact.h)("a", (0, _extends2.default)({
    target: target,
    rel: rel,
    href: (0, _absoluteUrlRuntime.resolveUrl)((_hit$topic_url = hit.topic_url) !== null && _hit$topic_url !== void 0 ? _hit$topic_url : ''),
    className: "algolia-hit-item button-click"
  }, getItemProps({
    item: hit,
    index: index,
    role: undefined
  }), {
    onMouseUp: function onMouseUp(e) {
      return e.stopPropagation();
    },
    "data-track-type": "click",
    "data-element-name": "Algolia hit item link" // data-toggle for Downshift component. This will keep the dropdown open and move focus to next "focusable" element
    ,
    "data-toggle": "button"
  }), (0, _preact.h)(_SearchResultIcon.default, {
    hit: hit
  }), (0, _preact.h)("span", {
    className: "algolia-hit-item--name"
  }, hit._highlightResult ? (0, _preact.h)(_components.DecodeHighlight, {
    attribute: "title",
    hit: hit,
    tagName: "strong"
  }) : parsedTitle, ' ', (0, _.isCommunityResult)(hit) && hit.content_type === 'article' && hit.article_label ? (0, _preact.h)("span", {
    className: "hit-item--meta"
  }, " ", hit.article_label, " ") : null)));
};

var _default = SearchResult;
exports.default = _default;